import { computed } from 'vue'
// import { GlobalStore } from "@packages/utils/stores"
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import en from 'element-plus/es/locale/lang/en'
// import "dayjs/locale/zh-cn"
// dayjs.locale("zh-cn")
export const useElconfig = () => {
	// const globalStore = GlobalStore()
	// 配置 按钮文字中间是否有空格element
	// globalStore.setInitThemeConfig()
	const buttonConfig = {
		autoInsertSpace: false
	}
	// 配置 全局组件大小 (small/default(medium)/large)
	const assemblySize = 'default'
	// 配置 中英文
	const language = ref('zh')
	const locale = computed(() => {
		if (language.value && language.value == 'en') return en
		return zhCn
	})

	return {
		buttonConfig,
		assemblySize,
		locale
	}
}
